module.exports = "/_next/static/videos/bikes-2-80511c32acab111ccbabad0c4b95f256.webm";